module.exports = __webpack_public_path__ + "img/laminate_two.2b44adc0.png";